import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

const sliders = document.querySelectorAll('.block-content-ratings .swiper');

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const mobileSlidesPerView = 1;
		const tabletSlidesPerView = 2;
		const desktopSmallSlidesPerView = 3;
		const desktopSlidesPerView = 4;

		const paginationElement =
			slider.parentElement.querySelector('.swiper-pagination');

		const settings = {
			loop: false,
			grabCursor: true,
			slidesPerView: mobileSlidesPerView,
			centeredSlides: false,
			spaceBetween: 8,
			modules: [A11y, Navigation, Pagination],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: slider.parentElement.querySelector(
					'.swiper-button-prev'
				),
				nextEl: slider.parentElement.querySelector(
					'.swiper-button-next'
				),
			},
			pagination: {
				el: paginationElement,
				clickable: false,
				dynamicBullets: false,
			},
			breakpoints: {
				768: {
					slidesPerView: tabletSlidesPerView,
					spaceBetween: 24,
				},
				1200: {
					slidesPerView: desktopSmallSlidesPerView,
					spaceBetween: 32,
				},
				1400: {
					slidesPerView: desktopSlidesPerView,
					spaceBetween: 32,
				},
			},
		};

		new Swiper(slider, settings);
	});
}
